export const STEM_LIST_LAST_UPDATED = '2024-07-23';

export interface StemCipCode {
  code: string;
  title: string;
  series: string;
}

export const STEM_CIP_CODES: StemCipCode[] = [
  // Series 01 — Agriculture, Agriculture Operations, and Related Sciences
  { code: '01.0308', title: 'Agroecology and Sustainable Agriculture', series: '01' },
  { code: '01.0901', title: 'Animal Sciences, General', series: '01' },
  { code: '01.0902', title: 'Agricultural Animal Breeding', series: '01' },
  { code: '01.0903', title: 'Animal Health', series: '01' },
  { code: '01.0904', title: 'Animal Nutrition', series: '01' },
  { code: '01.0905', title: 'Dairy Science', series: '01' },
  { code: '01.0906', title: 'Livestock Management', series: '01' },
  { code: '01.0907', title: 'Poultry Science', series: '01' },
  { code: '01.0999', title: 'Animal Sciences, Other', series: '01' },
  { code: '01.1001', title: 'Food Science', series: '01' },
  { code: '01.1002', title: 'Food Technology and Processing', series: '01' },
  { code: '01.1099', title: 'Food Science and Technology, Other', series: '01' },
  { code: '01.1101', title: 'Plant Sciences, General', series: '01' },
  { code: '01.1102', title: 'Agronomy and Crop Science', series: '01' },
  { code: '01.1103', title: 'Horticultural Science', series: '01' },
  { code: '01.1104', title: 'Agricultural and Horticultural Plant Breeding', series: '01' },
  { code: '01.1105', title: 'Plant Protection and Integrated Pest Management', series: '01' },
  { code: '01.1106', title: 'Range Science and Management', series: '01' },
  { code: '01.1199', title: 'Plant Sciences, Other', series: '01' },
  { code: '01.1201', title: 'Soil Science and Agronomy, General', series: '01' },
  { code: '01.1202', title: 'Soil Chemistry and Physics', series: '01' },
  { code: '01.1203', title: 'Soil Microbiology', series: '01' },
  { code: '01.1299', title: 'Soil Sciences, Other', series: '01' },

  // Series 03 — Natural Resources and Conservation
  { code: '03.0101', title: 'Natural Resources/Conservation, General', series: '03' },
  { code: '03.0104', title: 'Environmental Science', series: '03' },
  { code: '03.0201', title: 'Environmental Studies', series: '03' },
  { code: '03.0204', title: 'Environmental/Natural Resource Economics', series: '03' },
  { code: '03.0205', title: 'Water, Wetlands, and Marine Resources Management', series: '03' },
  { code: '03.0502', title: 'Forest Sciences and Biology', series: '03' },
  { code: '03.0508', title: 'Urban Forestry', series: '03' },
  { code: '03.0509', title: 'Wood Science and Wood Products/Pulp and Paper Technology', series: '03' },
  { code: '03.0601', title: 'Wildlife, Fish and Wildlands Science and Management', series: '03' },

  // Series 04 — Architecture and Related Services
  { code: '04.0902', title: 'Architectural and Building Sciences/Technology', series: '04' },

  // Series 09 — Communication, Journalism, and Related Programs
  { code: '09.0702', title: 'Digital Communication and Media/Multimedia', series: '09' },

  // Series 10 — Communications Technologies/Technicians and Support Services
  { code: '10.0304', title: 'Animation, Interactive Technology, Video Graphics and Special Effects', series: '10' },

  // Series 11 — Computer and Information Sciences and Support Services
  { code: '11.0101', title: 'Computer and Information Sciences, General', series: '11' },
  { code: '11.0102', title: 'Artificial Intelligence', series: '11' },
  { code: '11.0103', title: 'Information Technology', series: '11' },
  { code: '11.0104', title: 'Informatics', series: '11' },
  { code: '11.0105', title: 'Human-Centered Technology Design', series: '11' },
  { code: '11.0199', title: 'Computer and Information Sciences, Other', series: '11' },
  { code: '11.0201', title: 'Computer Programming/Programmer, General', series: '11' },
  { code: '11.0202', title: 'Computer Programming, Specific Applications', series: '11' },
  { code: '11.0203', title: 'Computer Programming, Vendor/Product Certification', series: '11' },
  { code: '11.0299', title: 'Computer Programming, Other', series: '11' },
  { code: '11.0301', title: 'Data Processing and Data Processing Technology/Technician', series: '11' },
  { code: '11.0401', title: 'Information Science/Studies', series: '11' },
  { code: '11.0501', title: 'Computer Systems Analysis/Analyst', series: '11' },
  { code: '11.0701', title: 'Computer Science', series: '11' },
  { code: '11.0801', title: 'Web Page, Digital/Multimedia and Information Resources Design', series: '11' },
  { code: '11.0802', title: 'Data Modeling/Warehousing and Database Administration', series: '11' },
  { code: '11.0803', title: 'Computer Graphics', series: '11' },
  { code: '11.0804', title: 'Modeling, Virtual Environments and Simulation', series: '11' },
  { code: '11.0899', title: 'Computer Software and Media Applications, Other', series: '11' },
  { code: '11.0901', title: 'Computer Systems Networking and Telecommunications', series: '11' },
  { code: '11.1001', title: 'Network and System Administration/Administrator', series: '11' },
  { code: '11.1002', title: 'System, Networking, and LAN/WAN Management/Manager', series: '11' },
  { code: '11.1003', title: 'Computer and Information Systems Security/Auditing/Information Assurance', series: '11' },
  { code: '11.1004', title: 'Web/Multimedia Management and Webmaster', series: '11' },
  { code: '11.1005', title: 'Information Technology Project Management', series: '11' },
  { code: '11.1006', title: 'Computer Support Specialist', series: '11' },
  { code: '11.1099', title: 'Computer/Information Technology Administration and Management, Other', series: '11' },
  { code: '11.9999', title: 'Computer and Information Sciences and Support Services, Other', series: '11' },

  // Series 13 — Education
  { code: '13.0501', title: 'Educational/Instructional Technology', series: '13' },
  { code: '13.0601', title: 'Educational Evaluation and Research', series: '13' },
  { code: '13.0603', title: 'Educational Statistics and Research Methods', series: '13' },

  // Series 14 — Engineering (ALL codes in this series qualify)
  { code: '14.0101', title: 'Engineering, General', series: '14' },
  { code: '14.0102', title: 'Pre-Engineering', series: '14' },
  { code: '14.0201', title: 'Aerospace, Aeronautical, and Astronautical/Space Engineering', series: '14' },
  { code: '14.0301', title: 'Agricultural Engineering', series: '14' },
  { code: '14.0401', title: 'Architectural Engineering', series: '14' },
  { code: '14.0501', title: 'Bioengineering and Biomedical Engineering', series: '14' },
  { code: '14.0601', title: 'Ceramic Sciences and Engineering', series: '14' },
  { code: '14.0701', title: 'Chemical Engineering', series: '14' },
  { code: '14.0702', title: 'Chemical and Biomolecular Engineering', series: '14' },
  { code: '14.0799', title: 'Chemical Engineering, Other', series: '14' },
  { code: '14.0801', title: 'Civil Engineering, General', series: '14' },
  { code: '14.0802', title: 'Geotechnical and Geoenvironmental Engineering', series: '14' },
  { code: '14.0803', title: 'Structural Engineering', series: '14' },
  { code: '14.0804', title: 'Transportation and Highway Engineering', series: '14' },
  { code: '14.0805', title: 'Water Resources Engineering', series: '14' },
  { code: '14.0899', title: 'Civil Engineering, Other', series: '14' },
  { code: '14.0901', title: 'Computer Engineering, General', series: '14' },
  { code: '14.0902', title: 'Computer Hardware Engineering', series: '14' },
  { code: '14.0903', title: 'Computer Software Engineering', series: '14' },
  { code: '14.0999', title: 'Computer Engineering, Other', series: '14' },
  { code: '14.1001', title: 'Electrical and Electronics Engineering', series: '14' },
  { code: '14.1003', title: 'Laser and Optical Engineering', series: '14' },
  { code: '14.1004', title: 'Telecommunications Engineering', series: '14' },
  { code: '14.1099', title: 'Electrical, Electronics, and Communications Engineering, Other', series: '14' },
  { code: '14.1101', title: 'Engineering Mechanics', series: '14' },
  { code: '14.1201', title: 'Engineering Physics/Applied Physics', series: '14' },
  { code: '14.1301', title: 'Engineering Science', series: '14' },
  { code: '14.1401', title: 'Environmental/Environmental Health Engineering', series: '14' },
  { code: '14.1801', title: 'Materials Engineering', series: '14' },
  { code: '14.1901', title: 'Mechanical Engineering', series: '14' },
  { code: '14.2001', title: 'Metallurgical Engineering', series: '14' },
  { code: '14.2101', title: 'Mining and Mineral Engineering', series: '14' },
  { code: '14.2201', title: 'Naval Architecture and Marine Engineering', series: '14' },
  { code: '14.2301', title: 'Nuclear Engineering', series: '14' },
  { code: '14.2401', title: 'Ocean Engineering', series: '14' },
  { code: '14.2501', title: 'Petroleum Engineering', series: '14' },
  { code: '14.2701', title: 'Systems Engineering', series: '14' },
  { code: '14.2801', title: 'Textile Sciences and Engineering', series: '14' },
  { code: '14.3201', title: 'Polymer/Plastics Engineering', series: '14' },
  { code: '14.3301', title: 'Construction Engineering', series: '14' },
  { code: '14.3401', title: 'Forest Engineering', series: '14' },
  { code: '14.3501', title: 'Industrial Engineering', series: '14' },
  { code: '14.3601', title: 'Manufacturing Engineering', series: '14' },
  { code: '14.3701', title: 'Operations Research', series: '14' },
  { code: '14.3801', title: 'Surveying Engineering', series: '14' },
  { code: '14.3901', title: 'Geological/Geophysical Engineering', series: '14' },
  { code: '14.4001', title: 'Paper Science and Engineering', series: '14' },
  { code: '14.4101', title: 'Electromechanical Engineering', series: '14' },
  { code: '14.4201', title: 'Mechatronics, Robotics, and Automation Engineering', series: '14' },
  { code: '14.4301', title: 'Biochemical Engineering', series: '14' },
  { code: '14.4401', title: 'Engineering Chemistry', series: '14' },
  { code: '14.4501', title: 'Biological/Biosystems Engineering', series: '14' },
  { code: '14.4701', title: 'Electrical and Computer Engineering', series: '14' },
  { code: '14.4801', title: 'Energy Systems Engineering', series: '14' },
  { code: '14.9999', title: 'Engineering, Other', series: '14' },

  // Series 15 — Engineering Technologies and Engineering-Related Fields
  { code: '15.0000', title: 'Engineering Technology, General', series: '15' },
  { code: '15.0101', title: 'Architectural Engineering Technology/Technician', series: '15' },
  { code: '15.0201', title: 'Civil Engineering Technology/Technician', series: '15' },
  { code: '15.0303', title: 'Electrical, Electronic, and Communications Engineering Technology/Technician', series: '15' },
  { code: '15.0304', title: 'Laser and Optical Technology/Technician', series: '15' },
  { code: '15.0305', title: 'Telecommunications Technology/Technician', series: '15' },
  { code: '15.0306', title: 'Integrated Circuit Design', series: '15' },
  { code: '15.0399', title: 'Electrical and Electronic Engineering Technologies/Technicians, Other', series: '15' },
  { code: '15.0401', title: 'Biomedical Technology/Technician', series: '15' },
  { code: '15.0403', title: 'Electromechanical Technology/Electromechanical Engineering Technology', series: '15' },
  { code: '15.0404', title: 'Instrumentation Technology/Technician', series: '15' },
  { code: '15.0405', title: 'Robotics Technology/Technician', series: '15' },
  { code: '15.0406', title: 'Automation Engineer Technology/Technician', series: '15' },
  { code: '15.0407', title: 'Mechatronics, Robotics, and Automation Engineering Technology/Technician', series: '15' },
  { code: '15.0499', title: 'Electromechanical and Instrumentation and Maintenance Technologies/Technicians, Other', series: '15' },
  { code: '15.0501', title: 'Heating, Ventilation, Air Conditioning and Refrigeration Engineering Technology/Technician', series: '15' },
  { code: '15.0503', title: 'Energy Management and Systems Technology/Technician', series: '15' },
  { code: '15.0505', title: 'Solar Energy Technology/Technician', series: '15' },
  { code: '15.0506', title: 'Water Quality and Wastewater Treatment Management and Recycling Technology/Technician', series: '15' },
  { code: '15.0507', title: 'Environmental Engineering Technology/Environmental Technology', series: '15' },
  { code: '15.0508', title: 'Hazardous Materials Management and Waste Technology/Technician', series: '15' },
  { code: '15.0599', title: 'Environmental Control Technologies/Technicians, Other', series: '15' },
  { code: '15.0607', title: 'Plastics and Polymer Engineering Technology/Technician', series: '15' },
  { code: '15.0611', title: 'Metallurgical Technology/Technician', series: '15' },
  { code: '15.0612', title: 'Industrial Technology/Technician', series: '15' },
  { code: '15.0613', title: 'Manufacturing Engineering Technology/Technician', series: '15' },
  { code: '15.0614', title: 'Welding Engineering Technology/Technician', series: '15' },
  { code: '15.0615', title: 'Chemical Engineering Technology/Technician', series: '15' },
  { code: '15.0616', title: 'Semiconductor Manufacturing Technology', series: '15' },
  { code: '15.0699', title: 'Industrial Production Technologies/Technicians, Other', series: '15' },
  { code: '15.0701', title: 'Occupational Safety and Health Technology/Technician', series: '15' },
  { code: '15.0702', title: 'Quality Control Technology/Technician', series: '15' },
  { code: '15.0703', title: 'Industrial Safety Technology/Technician', series: '15' },
  { code: '15.0704', title: 'Hazardous Materials Information Systems Technology/Technician', series: '15' },
  { code: '15.0799', title: 'Quality Control and Safety Technologies/Technicians, Other', series: '15' },
  { code: '15.0801', title: 'Aeronautical/Aerospace Engineering Technology/Technician', series: '15' },
  { code: '15.0803', title: 'Automotive Engineering Technology/Technician', series: '15' },
  { code: '15.0805', title: 'Mechanical Engineering/Mechanical Technology/Technician', series: '15' },
  { code: '15.0899', title: 'Mechanical Engineering Related Technologies/Technicians, Other', series: '15' },
  { code: '15.0901', title: 'Mining Technology/Technician', series: '15' },
  { code: '15.0903', title: 'Petroleum Technology/Technician', series: '15' },
  { code: '15.0999', title: 'Mining and Petroleum Technologies/Technicians, Other', series: '15' },
  { code: '15.1001', title: 'Construction Engineering Technology/Technician', series: '15' },
  { code: '15.1102', title: 'Surveying Technology/Surveying', series: '15' },
  { code: '15.1103', title: 'Hydraulics and Fluid Power Technology/Technician', series: '15' },
  { code: '15.1199', title: 'Engineering-Related Technologies, Other', series: '15' },
  { code: '15.1201', title: 'Computer Engineering Technology/Technician', series: '15' },
  { code: '15.1202', title: 'Computer Technology/Computer Systems Technology', series: '15' },
  { code: '15.1203', title: 'Computer Hardware Technology/Technician', series: '15' },
  { code: '15.1204', title: 'Computer/Computer Systems Technology/Technician', series: '15' },
  { code: '15.1299', title: 'Computer Engineering Technologies/Technicians, Other', series: '15' },
  { code: '15.1301', title: 'Drafting and Design Technology/Technician, General', series: '15' },
  { code: '15.1302', title: 'CAD/CADD Drafting and/or Design Technology/Technician', series: '15' },
  { code: '15.1399', title: 'Drafting/Design Engineering Technologies/Technicians, Other', series: '15' },
  { code: '15.1401', title: 'Nuclear Engineering Technology/Technician', series: '15' },
  { code: '15.1501', title: 'Engineering/Industrial Management', series: '15' },
  { code: '15.1601', title: 'Nanotechnology', series: '15' },
  { code: '15.9999', title: 'Engineering Technologies and Engineering-Related Fields, Other', series: '15' },

  // Series 26 — Biological and Biomedical Sciences (ALL codes qualify)
  { code: '26.0101', title: 'Biology/Biological Sciences, General', series: '26' },
  { code: '26.0102', title: 'Biomedical Sciences, General', series: '26' },
  { code: '26.0202', title: 'Biochemistry', series: '26' },
  { code: '26.0203', title: 'Biophysics', series: '26' },
  { code: '26.0204', title: 'Molecular Biology', series: '26' },
  { code: '26.0205', title: 'Molecular Biochemistry', series: '26' },
  { code: '26.0206', title: 'Molecular Biophysics', series: '26' },
  { code: '26.0207', title: 'Structural Biology', series: '26' },
  { code: '26.0208', title: 'Photobiology', series: '26' },
  { code: '26.0209', title: 'Radiation Biology/Radiobiology', series: '26' },
  { code: '26.0210', title: 'Biochemistry and Molecular Biology', series: '26' },
  { code: '26.0299', title: 'Biochemistry, Biophysics and Molecular Biology, Other', series: '26' },
  { code: '26.0301', title: 'Botany/Plant Biology', series: '26' },
  { code: '26.0305', title: 'Plant Pathology/Phytopathology', series: '26' },
  { code: '26.0307', title: 'Plant Physiology', series: '26' },
  { code: '26.0308', title: 'Plant Molecular Biology', series: '26' },
  { code: '26.0399', title: 'Botany/Plant Biology, Other', series: '26' },
  { code: '26.0401', title: 'Cell/Cellular Biology and Histology', series: '26' },
  { code: '26.0403', title: 'Anatomy', series: '26' },
  { code: '26.0404', title: 'Developmental Biology and Embryology', series: '26' },
  { code: '26.0406', title: 'Cell/Cellular and Molecular Biology', series: '26' },
  { code: '26.0407', title: 'Cell Biology and Anatomy', series: '26' },
  { code: '26.0499', title: 'Cell/Cellular Biology and Anatomical Sciences, Other', series: '26' },
  { code: '26.0501', title: 'Microbiology, General', series: '26' },
  { code: '26.0502', title: 'Microbiology and Immunology', series: '26' },
  { code: '26.0503', title: 'Medical Microbiology and Bacteriology', series: '26' },
  { code: '26.0504', title: 'Virology', series: '26' },
  { code: '26.0505', title: 'Parasitology', series: '26' },
  { code: '26.0506', title: 'Mycology', series: '26' },
  { code: '26.0507', title: 'Immunology', series: '26' },
  { code: '26.0599', title: 'Microbiology Sciences and Immunology, Other', series: '26' },
  { code: '26.0701', title: 'Zoology/Animal Biology', series: '26' },
  { code: '26.0702', title: 'Entomology', series: '26' },
  { code: '26.0707', title: 'Animal Physiology', series: '26' },
  { code: '26.0708', title: 'Animal Behavior and Ethology', series: '26' },
  { code: '26.0709', title: 'Wildlife Biology', series: '26' },
  { code: '26.0799', title: 'Zoology/Animal Biology, Other', series: '26' },
  { code: '26.0801', title: 'Genetics, General', series: '26' },
  { code: '26.0802', title: 'Molecular Genetics', series: '26' },
  { code: '26.0803', title: 'Microbial and Eukaryotic Genetics', series: '26' },
  { code: '26.0804', title: 'Animal Genetics', series: '26' },
  { code: '26.0805', title: 'Plant Genetics', series: '26' },
  { code: '26.0806', title: 'Human/Medical Genetics', series: '26' },
  { code: '26.0807', title: 'Genome Sciences/Genomics', series: '26' },
  { code: '26.0899', title: 'Genetics, Other', series: '26' },
  { code: '26.0901', title: 'Physiology, General', series: '26' },
  { code: '26.0902', title: 'Molecular Physiology', series: '26' },
  { code: '26.0903', title: 'Cell Physiology', series: '26' },
  { code: '26.0904', title: 'Endocrinology', series: '26' },
  { code: '26.0905', title: 'Reproductive Biology', series: '26' },
  { code: '26.0907', title: 'Cardiovascular Science', series: '26' },
  { code: '26.0908', title: 'Exercise Physiology', series: '26' },
  { code: '26.0909', title: 'Vision Science/Physiological Optics', series: '26' },
  { code: '26.0910', title: 'Pathology/Experimental Pathology', series: '26' },
  { code: '26.0911', title: 'Oncology and Cancer Biology', series: '26' },
  { code: '26.0912', title: 'Aerospace Physiology and Medicine', series: '26' },
  { code: '26.0999', title: 'Physiology, Pathology, and Related Sciences, Other', series: '26' },
  { code: '26.1001', title: 'Pharmacology', series: '26' },
  { code: '26.1002', title: 'Molecular Pharmacology', series: '26' },
  { code: '26.1003', title: 'Neuropharmacology', series: '26' },
  { code: '26.1004', title: 'Toxicology', series: '26' },
  { code: '26.1005', title: 'Molecular Toxicology', series: '26' },
  { code: '26.1006', title: 'Environmental Toxicology', series: '26' },
  { code: '26.1007', title: 'Pharmacology and Toxicology', series: '26' },
  { code: '26.1099', title: 'Pharmacology and Toxicology, Other', series: '26' },
  { code: '26.1101', title: 'Biometry/Biometrics', series: '26' },
  { code: '26.1102', title: 'Biostatistics', series: '26' },
  { code: '26.1103', title: 'Bioinformatics', series: '26' },
  { code: '26.1104', title: 'Computational Biology', series: '26' },
  { code: '26.1199', title: 'Biomathematics, Bioinformatics, and Computational Biology, Other', series: '26' },
  { code: '26.1201', title: 'Biotechnology', series: '26' },
  { code: '26.1301', title: 'Ecology', series: '26' },
  { code: '26.1302', title: 'Marine Biology and Biological Oceanography', series: '26' },
  { code: '26.1303', title: 'Evolutionary Biology', series: '26' },
  { code: '26.1304', title: 'Aquatic Biology/Limnology', series: '26' },
  { code: '26.1305', title: 'Environmental Biology', series: '26' },
  { code: '26.1306', title: 'Population Biology', series: '26' },
  { code: '26.1307', title: 'Conservation Biology', series: '26' },
  { code: '26.1308', title: 'Systematic Biology/Biological Systematics', series: '26' },
  { code: '26.1309', title: 'Epidemiology', series: '26' },
  { code: '26.1310', title: 'Ecology and Evolutionary Biology', series: '26' },
  { code: '26.1399', title: 'Ecology, Evolution, Systematics, and Population Biology, Other', series: '26' },
  { code: '26.1401', title: 'Molecular Medicine', series: '26' },
  { code: '26.1501', title: 'Neuroscience', series: '26' },
  { code: '26.1502', title: 'Neuroanatomy', series: '26' },
  { code: '26.1503', title: 'Neurobiology and Anatomy', series: '26' },
  { code: '26.1504', title: 'Neurobiology and Behavior', series: '26' },
  { code: '26.1599', title: 'Neurobiology and Neurosciences, Other', series: '26' },
  { code: '26.9999', title: 'Biological and Biomedical Sciences, Other', series: '26' },

  // Series 27 — Mathematics and Statistics (ALL codes qualify)
  { code: '27.0101', title: 'Mathematics, General', series: '27' },
  { code: '27.0102', title: 'Algebra and Number Theory', series: '27' },
  { code: '27.0103', title: 'Analysis and Functional Analysis', series: '27' },
  { code: '27.0104', title: 'Geometry/Geometric Analysis', series: '27' },
  { code: '27.0105', title: 'Topology and Foundations', series: '27' },
  { code: '27.0199', title: 'Mathematics, Other', series: '27' },
  { code: '27.0301', title: 'Applied Mathematics, General', series: '27' },
  { code: '27.0303', title: 'Computational Mathematics', series: '27' },
  { code: '27.0304', title: 'Computational and Applied Mathematics', series: '27' },
  { code: '27.0305', title: 'Financial Mathematics', series: '27' },
  { code: '27.0306', title: 'Mathematical Biology', series: '27' },
  { code: '27.0399', title: 'Applied Mathematics, Other', series: '27' },
  { code: '27.0501', title: 'Statistics, General', series: '27' },
  { code: '27.0502', title: 'Mathematical Statistics and Probability', series: '27' },
  { code: '27.0503', title: 'Mathematics and Statistics', series: '27' },
  { code: '27.0599', title: 'Statistics, Other', series: '27' },
  { code: '27.0601', title: 'Applied Statistics, General', series: '27' },
  { code: '27.9999', title: 'Mathematics and Statistics, Other', series: '27' },

  // Series 28 — Military Science, Leadership, and Operational Art
  { code: '28.0501', title: 'Air Science/Airpower Studies', series: '28' },
  { code: '28.0502', title: 'Air and Space Operational Art and Science', series: '28' },

  // Series 29 — Military Technologies and Applied Sciences
  { code: '29.0201', title: 'Intelligence, Command Control and Information Operations', series: '29' },
  { code: '29.0202', title: 'Information Operations/Joint Information Operations', series: '29' },
  { code: '29.0203', title: 'Information/Psychological Warfare and Military Media Relations', series: '29' },
  { code: '29.0204', title: 'Cyber/Electronic Operations and Warfare', series: '29' },
  { code: '29.0207', title: 'Signals Intelligence/Signal Analysis', series: '29' },
  { code: '29.0299', title: 'Intelligence, Command Control and Information Operations, Other', series: '29' },
  { code: '29.0301', title: 'Combat Systems Engineering', series: '29' },
  { code: '29.0302', title: 'Directed Energy Systems', series: '29' },
  { code: '29.0303', title: 'Engineering Acoustics', series: '29' },
  { code: '29.0304', title: 'Low-Observables and Stealth Technology', series: '29' },
  { code: '29.0305', title: 'Space Systems Operations', series: '29' },
  { code: '29.0306', title: 'Undersea Warfare', series: '29' },
  { code: '29.0399', title: 'Military Applied Sciences, Other', series: '29' },
  { code: '29.0401', title: 'Aerospace Ground Equipment Technology', series: '29' },
  { code: '29.0402', title: 'Air and Space Operations Technology', series: '29' },
  { code: '29.0403', title: 'Aircraft Armament Systems Technology', series: '29' },
  { code: '29.0404', title: 'Explosive Ordnance/Bomb Disposal', series: '29' },
  { code: '29.0405', title: 'Joint Command/Task Force (C3, C4I) Systems', series: '29' },
  { code: '29.0406', title: 'Military Information Systems Technology', series: '29' },
  { code: '29.0407', title: 'Missile and Space Systems Technology', series: '29' },
  { code: '29.0408', title: 'Munitions Systems/Ordnance Technology', series: '29' },
  { code: '29.0409', title: 'Radar Communications and Systems Technology', series: '29' },
  { code: '29.0499', title: 'Military Systems and Maintenance Technology, Other', series: '29' },
  { code: '29.9999', title: 'Military Technologies and Applied Sciences, Other', series: '29' },

  // Series 30 — Multi/Interdisciplinary Studies
  { code: '30.0101', title: 'Biological and Physical Sciences', series: '30' },
  { code: '30.0601', title: 'Systems Science and Theory', series: '30' },
  { code: '30.0801', title: 'Mathematics and Computer Science', series: '30' },
  { code: '30.1001', title: 'Biopsychology', series: '30' },
  { code: '30.1801', title: 'Natural Sciences', series: '30' },
  { code: '30.1901', title: 'Nutrition Sciences', series: '30' },
  { code: '30.2501', title: 'Cognitive Science', series: '30' },
  { code: '30.2701', title: 'Human Biology', series: '30' },
  { code: '30.3001', title: 'Computational Science', series: '30' },
  { code: '30.3101', title: 'Human Computer Interaction', series: '30' },
  { code: '30.3201', title: 'Marine Sciences', series: '30' },
  { code: '30.3301', title: 'Sustainability Studies', series: '30' },
  { code: '30.3401', title: 'Anthrozoology', series: '30' },
  { code: '30.3501', title: 'Climate Science', series: '30' },
  { code: '30.3601', title: 'Cultural Analytics', series: '30' },
  { code: '30.3701', title: 'Data Science, General', series: '30' },
  { code: '30.3702', title: 'Data Analytics, General', series: '30' },
  { code: '30.3801', title: 'Earth Systems Science', series: '30' },
  { code: '30.3901', title: 'Economics and Computer Science', series: '30' },
  { code: '30.4001', title: 'Environmental Geosciences', series: '30' },
  { code: '30.4101', title: 'Geobiology', series: '30' },
  { code: '30.4201', title: 'Geography and Environmental Studies', series: '30' },
  { code: '30.4301', title: 'Geospatial Intelligence', series: '30' },
  { code: '30.4801', title: 'Linguistics and Computer Science', series: '30' },
  { code: '30.4901', title: 'Mathematical Economics', series: '30' },
  { code: '30.5001', title: 'Mathematics and Atmospheric/Oceanic Science', series: '30' },
  { code: '30.7001', title: 'Data Science', series: '30' },
  { code: '30.7101', title: 'Data Analytics', series: '30' },

  // Series 40 — Physical Sciences (ALL codes qualify)
  { code: '40.0101', title: 'Physical Sciences', series: '40' },
  { code: '40.0201', title: 'Astronomy', series: '40' },
  { code: '40.0202', title: 'Astrophysics', series: '40' },
  { code: '40.0203', title: 'Astronomy and Astrophysics', series: '40' },
  { code: '40.0204', title: 'Planetary Astronomy and Science', series: '40' },
  { code: '40.0299', title: 'Astronomy and Astrophysics, Other', series: '40' },
  { code: '40.0401', title: 'Atmospheric Sciences and Meteorology, General', series: '40' },
  { code: '40.0402', title: 'Atmospheric Chemistry and Climatology', series: '40' },
  { code: '40.0403', title: 'Atmospheric Physics and Dynamics', series: '40' },
  { code: '40.0404', title: 'Meteorology', series: '40' },
  { code: '40.0499', title: 'Atmospheric Sciences and Meteorology, Other', series: '40' },
  { code: '40.0501', title: 'Chemistry, General', series: '40' },
  { code: '40.0502', title: 'Analytical Chemistry', series: '40' },
  { code: '40.0503', title: 'Inorganic Chemistry', series: '40' },
  { code: '40.0504', title: 'Organic Chemistry', series: '40' },
  { code: '40.0506', title: 'Physical Chemistry', series: '40' },
  { code: '40.0507', title: 'Polymer Chemistry', series: '40' },
  { code: '40.0508', title: 'Chemical Physics', series: '40' },
  { code: '40.0509', title: 'Environmental Chemistry', series: '40' },
  { code: '40.0510', title: 'Forensic Chemistry', series: '40' },
  { code: '40.0511', title: 'Theoretical Chemistry', series: '40' },
  { code: '40.0512', title: 'Cheminformatics/Chemistry Informatics', series: '40' },
  { code: '40.0599', title: 'Chemistry, Other', series: '40' },
  { code: '40.0601', title: 'Geology/Earth Science, General', series: '40' },
  { code: '40.0602', title: 'Geochemistry', series: '40' },
  { code: '40.0603', title: 'Geophysics and Seismology', series: '40' },
  { code: '40.0604', title: 'Paleontology', series: '40' },
  { code: '40.0605', title: 'Hydrology and Water Resources Science', series: '40' },
  { code: '40.0606', title: 'Geochemistry and Petrology', series: '40' },
  { code: '40.0607', title: 'Oceanography, Chemical and Physical', series: '40' },
  { code: '40.0699', title: 'Geological and Earth Sciences/Geosciences, Other', series: '40' },
  { code: '40.0801', title: 'Physics, General', series: '40' },
  { code: '40.0802', title: 'Atomic/Molecular Physics', series: '40' },
  { code: '40.0804', title: 'Elementary Particle Physics', series: '40' },
  { code: '40.0805', title: 'Plasma and High-Temperature Physics', series: '40' },
  { code: '40.0806', title: 'Nuclear Physics', series: '40' },
  { code: '40.0807', title: 'Optics/Optical Sciences', series: '40' },
  { code: '40.0808', title: 'Condensed Matter and Materials Physics', series: '40' },
  { code: '40.0809', title: 'Acoustics', series: '40' },
  { code: '40.0810', title: 'Theoretical and Mathematical Physics', series: '40' },
  { code: '40.0899', title: 'Physics, Other', series: '40' },
  { code: '40.1001', title: 'Materials Science', series: '40' },
  { code: '40.1002', title: 'Materials Chemistry', series: '40' },
  { code: '40.1099', title: 'Materials Sciences, Other', series: '40' },
  { code: '40.9999', title: 'Physical Sciences, Other', series: '40' },

  // Series 41 — Science Technologies/Technicians
  { code: '41.0101', title: 'Biology Technician/Biotechnology Laboratory Technician', series: '41' },
  { code: '41.0204', title: 'Industrial Radiologic Technology/Technician', series: '41' },
  { code: '41.0205', title: 'Nuclear/Nuclear Power Technology/Technician', series: '41' },
  { code: '41.0299', title: 'Nuclear and Industrial Radiologic Technologies/Technicians, Other', series: '41' },
  { code: '41.0301', title: 'Chemical Technology/Technician', series: '41' },
  { code: '41.9999', title: 'Science Technologies/Technicians, Other', series: '41' },

  // Series 42 — Psychology
  { code: '42.2701', title: 'Cognitive Psychology and Psycholinguistics', series: '42' },
  { code: '42.2702', title: 'Comparative Psychology', series: '42' },
  { code: '42.2703', title: 'Developmental and Child Psychology', series: '42' },
  { code: '42.2704', title: 'Experimental Psychology', series: '42' },
  { code: '42.2705', title: 'Personality Psychology', series: '42' },
  { code: '42.2706', title: 'Behavioral Neuroscience', series: '42' },
  { code: '42.2707', title: 'Social Psychology', series: '42' },
  { code: '42.2708', title: 'Psychometrics and Quantitative Psychology', series: '42' },
  { code: '42.2709', title: 'Psychopharmacology', series: '42' },
  { code: '42.2710', title: 'Research and Experimental Psychology', series: '42' },
  { code: '42.2711', title: 'Developmental and Adolescent Psychology', series: '42' },
  { code: '42.2799', title: 'Research and Experimental Psychology, Other', series: '42' },

  // Series 43 — Homeland Security, Law Enforcement, Firefighting
  { code: '43.0106', title: 'Forensic Science and Technology', series: '43' },
  { code: '43.0116', title: 'Cyber/Computer Forensics and Counterterrorism', series: '43' },
  { code: '43.0403', title: 'Digital Forensics', series: '43' },

  // Series 45 — Social Sciences
  { code: '45.0301', title: 'Archeology', series: '45' },
  { code: '45.0603', title: 'Econometrics and Quantitative Economics', series: '45' },
  { code: '45.0702', title: 'Geographic Information Science and Cartography', series: '45' },
  { code: '45.0701', title: 'Geography', series: '45' },
  { code: '45.0799', title: 'Geography, Other', series: '45' },

  // Series 49 — Transportation and Materials Moving
  { code: '49.0101', title: 'Aeronautics/Aviation/Aerospace Science and Technology, General', series: '49' },
  { code: '49.0104', title: 'Aviation/Airway Management and Operations', series: '49' },

  // Series 51 — Health Professions and Related Programs
  { code: '51.0701', title: 'Health/Health Care Administration/Management', series: '51' },
  { code: '51.0706', title: 'Health Information/Medical Records Administration/Administrator', series: '51' },
  { code: '51.0707', title: 'Health Information/Medical Records Technology/Technician', series: '51' },
  { code: '51.0709', title: 'Medical Office Computer Specialist/Assistant', series: '51' },
  { code: '51.0710', title: 'Medical Office Management/Administration', series: '51' },
  { code: '51.0711', title: 'Medical/Health Management and Clinical Assistant/Specialist', series: '51' },
  { code: '51.0712', title: 'Medical Staff Services Technology/Technician', series: '51' },
  { code: '51.0713', title: 'Medical Insurance Coding Specialist/Coder', series: '51' },
  { code: '51.0716', title: 'Medical Insurance Specialist/Medical Biller', series: '51' },
  { code: '51.0718', title: 'Long Term Care Administration/Management', series: '51' },
  { code: '51.0799', title: 'Health and Medical Administrative Services, Other', series: '51' },
  { code: '51.1002', title: 'Cytotechnology/Cytotechnologist', series: '51' },
  { code: '51.1003', title: 'Hematology Technology/Technician', series: '51' },
  { code: '51.1005', title: 'Clinical Laboratory Science/Medical Technology/Technologist', series: '51' },
  { code: '51.1009', title: 'Phlebotomy Technician/Phlebotomist', series: '51' },
  { code: '51.1010', title: 'Histologic Technology/Histotechnologist', series: '51' },
  { code: '51.1011', title: 'Renal/Dialysis Technologist/Technician', series: '51' },
  { code: '51.1012', title: 'Sterile Processing Technology/Technician', series: '51' },
  { code: '51.1099', title: 'Clinical/Medical Laboratory Science and Allied Professions, Other', series: '51' },
  { code: '51.2003', title: 'Pharmaceutics and Drug Design', series: '51' },
  { code: '51.2004', title: 'Medicinal and Pharmaceutical Chemistry', series: '51' },
  { code: '51.2005', title: 'Natural Products Chemistry and Pharmacognosy', series: '51' },
  { code: '51.2006', title: 'Clinical and Industrial Drug Development', series: '51' },
  { code: '51.2007', title: 'Pharmacoeconomics/Pharmaceutical Economics', series: '51' },
  { code: '51.2009', title: 'Industrial and Physical Pharmacy and Cosmetic Sciences', series: '51' },
  { code: '51.2010', title: 'Pharmaceutical Sciences', series: '51' },
  { code: '51.2099', title: 'Pharmacy, Pharmaceutical Sciences, and Administration, Other', series: '51' },
  { code: '51.2202', title: 'Environmental Health', series: '51' },
  { code: '51.2205', title: 'Health/Medical Physics', series: '51' },
  { code: '51.2206', title: 'Occupational Health and Industrial Hygiene', series: '51' },
  { code: '51.2210', title: 'International Public Health/International Health', series: '51' },
  { code: '51.2299', title: 'Public Health, Other', series: '51' },
  { code: '51.2502', title: 'Veterinary Anatomy', series: '51' },
  { code: '51.2503', title: 'Veterinary Physiology', series: '51' },
  { code: '51.2504', title: 'Veterinary Microbiology and Immunobiology', series: '51' },
  { code: '51.2505', title: 'Veterinary Pathology and Pathobiology', series: '51' },
  { code: '51.2506', title: 'Veterinary Toxicology and Pharmacology', series: '51' },
  { code: '51.2507', title: 'Large Animal/Food Animal and Equine Surgery and Medicine', series: '51' },
  { code: '51.2508', title: 'Small/Companion Animal Surgery and Medicine', series: '51' },
  { code: '51.2509', title: 'Comparative and Laboratory Animal Medicine', series: '51' },
  { code: '51.2510', title: 'Veterinary Preventive Medicine, Epidemiology, and Public Health', series: '51' },
  { code: '51.2511', title: 'Veterinary Infectious Diseases', series: '51' },
  { code: '51.2599', title: 'Veterinary Biomedical and Clinical Sciences, Other', series: '51' },
  { code: '51.2703', title: 'Medical Informatics', series: '51' },
  { code: '51.2706', title: 'Health Informatics', series: '51' },
  { code: '51.2799', title: 'Medical Illustration and Informatics, Other', series: '51' },

  // Series 52 — Business, Management, Marketing, and Related Support Services
  { code: '52.0101', title: 'Business/Commerce, General', series: '52' },
  { code: '52.0601', title: 'Business/Managerial Economics', series: '52' },
  { code: '52.0701', title: 'Entrepreneurship/Entrepreneurial Studies', series: '52' },
  { code: '52.0801', title: 'Finance, General', series: '52' },
  { code: '52.0802', title: 'Actuarial Science', series: '52' },
  { code: '52.0803', title: 'Banking and Financial Support Services', series: '52' },
  { code: '52.0804', title: 'Financial Planning and Services', series: '52' },
  { code: '52.0807', title: 'Investments and Securities', series: '52' },
  { code: '52.0899', title: 'Finance and Financial Management Services, Other', series: '52' },
  { code: '52.1001', title: 'Human Resources Management/Personnel Administration, General', series: '52' },
  { code: '52.1002', title: 'Labor and Industrial Relations', series: '52' },
  { code: '52.1003', title: 'Organizational Behavior Studies', series: '52' },
  { code: '52.1004', title: 'Labor Studies', series: '52' },
  { code: '52.1005', title: 'Human Resources Development', series: '52' },
  { code: '52.1099', title: 'Human Resources Management and Services, Other', series: '52' },
  { code: '52.1201', title: 'Management Information Systems, General', series: '52' },
  { code: '52.1206', title: 'Information Resources Management', series: '52' },
  { code: '52.1207', title: 'Knowledge Management', series: '52' },
  { code: '52.1299', title: 'Management Information Systems and Services, Other', series: '52' },
  { code: '52.1301', title: 'Management Science', series: '52' },
  { code: '52.1302', title: 'Business Statistics', series: '52' },
  { code: '52.1304', title: 'Actuarial Science', series: '52' },
  { code: '52.1399', title: 'Management Sciences and Quantitative Methods, Other', series: '52' },
  { code: '52.1401', title: 'Marketing/Marketing Management, General', series: '52' },
  { code: '52.1402', title: 'Marketing Research', series: '52' },
  { code: '52.1499', title: 'Marketing, Other', series: '52' },
];
